'use client';

import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  AccordionUI,
  Typography
} from 'components';
import { usePathname, useRouter } from 'next/navigation';

import { FC, PropsWithChildren, useCallback } from 'react';
import { cn } from 'utils/cn';
import { IMenuItem } from './MenuItem';
import { factoryMenuActiveRule } from './useMenu';

const MenuExpansive: FC<PropsWithChildren<IMenuItem>> = ({
  children,
  iconActive,
  iconInactive,
  visible,
  name,
  route = '',
  childrens = []
}) => {
  const router = useRouter();
  const pathname = usePathname();

  const handleOnClick = useCallback(() => router.push(route), [route, router]);

  const active =
    factoryMenuActiveRule(route, pathname) ||
    childrens?.some((child) => factoryMenuActiveRule(child?.route, pathname));

  if (!visible) return null;

  return (
    <AccordionUI
      type="single"
      className="w-full"
      collapsible
      {...(active ? { defaultValue: route } : {})}
    >
      <AccordionItem value={route}>
        <AccordionTrigger
          className={cn(
            'mb-1',
            'transition-colors duration-200 ease-in-out',
            'focus-visible:ring-offset-primary-blue-500/75',
            'focus:outline-none focus-visible:ring',
            'mb-1 rounded-lg px-2 py-2 hover:bg-gray-100'
          )}
          onClick={handleOnClick}
        >
          <div className="flex gap-2">
            {active ? iconActive : iconInactive}
            <Typography
              variant={active ? 'medium3' : 'light3'}
              className={cn(
                'user-select-none h-7 select-none transition-all duration-200 ',
                active ? 'text-tertiary-100' : 'pt-[3px] text-tertiary-300'
              )}
            >
              {name}
            </Typography>
          </div>
        </AccordionTrigger>
        <AccordionContent className="flex flex-col !pb-0 pl-4">{children}</AccordionContent>
      </AccordionItem>
    </AccordionUI>
  );
};

export default MenuExpansive;
